const empresa = 2;

const getDados = () => {
    /*return {
        API_URL: 'http://192.168.1.6:3006/api',
        OAPI_URL: 'http://192.168.1.6:3006/oapi'

    }*/

    if (empresa === 0) { // Homologacao
        return {
            API_URL: 'http://192.168.1.5:3003/api',
            OAPI_URL: 'http://192.168.1.5:3003/oapi'

        }
    }
    if (empresa === 1) {// SENAP
        return {
            API_URL: 'https://sdrsp.sdrweb.net.br/api',
            OAPI_URL: 'https://sdrsp.sdrweb.net.br/oapi'

        }
    }
    if (empresa === 2) {// MAIS UNIVIDA
        return {
            API_URL: 'https://bolunivida.sdrweb.net.br/api',
            OAPI_URL: 'https://bolunivida.sdrweb.net.br/oapi'
        }
    }
}



export default getDados();


//PRODUÇÃO senap
/*export default {
    API_URL: 'https://sdrweb.net.br:3006/api',
    OAPI_URL: 'https://sdrweb.net.br:3006/oapi'
    
}*/

/*//PRODUÇÃO maisunivida
export default {
    API_URL: 'https://sdrweb.net.br:3003/api',
    OAPI_URL: 'https://sdrweb.net.br:3003/oapi'
    
}*/


// WEBPACK FOOTER //
// ./src/consts.js